import { FrontendToolHandler } from '../types'
import { getActiveAgentBus, isAgentBusBound, type Fdc3LiteContext } from '../fdc3Bridge'

/**
 * `shareContext` (Spec 010 §7) — publish a context on Ali's linked channel via
 * FDC3 `broadcast` so other workspace apps react. Visible action card, no modal:
 * it stays within the entitlement-gated, same-workspace channel (§7.3).
 *
 * Only offered when Ali is bound to a Desktop Agent (mirrors `launchApp`'s
 * page-scoped `enabled` guard); a no-op off the bus.
 */
export const shareContext: FrontendToolHandler = {
  enabled: isAgentBusBound,
  definition: {
    name: 'shareContext',
    description:
      'Share a context (e.g. an instrument or fund) on the linked channel so other apps react.',
    parameters: {
      type: 'object',
      properties: {
        context: {
          type: 'object',
          description: 'An FDC3 context object with a string `type`, e.g. fdc3.instrument.'
        }
      },
      required: ['context']
    },
    requiresConfirmation: false
  },
  execute: async (args) => {
    const bus = getActiveAgentBus()
    if (!bus || !bus.isBound()) {
      return { success: false, message: 'Ali is not connected to a workspace bus.' }
    }
    const context = args.context as Fdc3LiteContext
    if (!context || typeof context.type !== 'string') {
      return { success: false, message: 'A context with a string `type` is required.' }
    }
    const result = await bus.shareContext(context)
    return { success: result.ok, message: result.message, data: result.data }
  }
}
